import { useEffect } from "react";
import { useSessionDataStore } from "./useSessionDataStore";

export const useMicrophoneTimer = (microphoneEnabled: boolean): void => {
  const {
    addMicrophoneEnabledDuration,
    microphoneLastEnabledTime,
    setMicrophoneLastEnabledTime,
  } = useSessionDataStore();

  useEffect(() => {
    if (microphoneEnabled) {
      const microphoneEnabledTimestamp = performance.now();
      setMicrophoneLastEnabledTime(microphoneEnabledTimestamp);
    } else {
      const microphoneDisabledTimestamp = performance.now();
      if (microphoneLastEnabledTime !== undefined) {
        addMicrophoneEnabledDuration(
          (microphoneDisabledTimestamp - microphoneLastEnabledTime) / 1000
        );
      }
    }
  }, [microphoneEnabled]);
};
